import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Root index route.
 *
 * `/` redirects to `/dashboard`. The actual auth check happens in the
 * `_authenticated` layout — if the user is not authenticated, the dashboard
 * route's beforeLoad will bounce them to `/login?returnTo=/dashboard`.
 *
 * Story E01.07 AC-09.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
